(function(){
  'use strict';
  if(window.cbWhatsAppQuoteReady){return;}
  window.cbWhatsAppQuoteReady=true;

  function formatMoney(cents,currency){
    try{
      return new Intl.NumberFormat('es-ES',{style:'currency',currency:currency||'EUR',minimumFractionDigits:2}).format((Number(cents)||0)/100);
    }catch(error){
      return ((Number(cents)||0)/100).toFixed(2).replace('.',',')+' €';
    }
  }

  function cartEndpoint(){
    var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return base.replace(/\/?$/,'/')+'cart.js';
  }

  function fetchCurrentCart(){
    return fetch(cartEndpoint(),{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(response){
        if(!response.ok){throw new Error('No se puede leer el carrito');}
        return response.json();
      });
  }

  function describeProperties(properties){
    if(!properties){return [];}
    var omitted={
      'Fabricación':true,
      'Medidas comprobadas':true,
      'Confirmación fabricación a medida':true
    };
    return Object.keys(properties).filter(function(key){
      var value=properties[key];
      return key&&key.charAt(0)!=='_'&&!omitted[key]&&value!==null&&value!==undefined&&value!==''&&value!==false;
    }).map(function(key){
      var value=properties[key];
      var content=Array.isArray(value)?value.join(', '):String(value);
      return key+': '+content;
    });
  }

  function quoteText(cart,details){
    var currency=cart.currency||'EUR';
    var lines=[
      'Hola, solicito presupuesto para estas piezas de CocinaBarata, sin realizar el pago todavía.',
      '',
      '*MI SELECCIÓN*'
    ];
    (cart.items||[]).forEach(function(item,index){
      var title=item.product_title||item.title||'Producto';
      var quantity=Number(item.quantity)||1;
      var linePrice=item.final_line_price;
      if(linePrice===undefined||linePrice===null){linePrice=item.line_price;}
      lines.push('');
      lines.push((index+1)+'. *'+title+'*');
      if(item.variant_title&&item.variant_title!=='Default Title'&&item.variant_title!=='Default'){
        lines.push('   Variante: '+item.variant_title);
      }
      describeProperties(item.properties).forEach(function(line){lines.push(line);});
      lines.push('   Cantidad: '+quantity);
      lines.push('   Importe: '+formatMoney(linePrice,currency));
    });
    lines.push('');
    lines.push('*Subtotal orientativo (IVA incluido): '+formatMoney(cart.total_price,currency)+'*');
    lines.push('Transporte no incluido; solicito valoración para mi destino antes de confirmar el pedido.');
    lines.push('Recogida en el taller de Badalona con cita previa, si procede.');
    lines.push('');
    lines.push('¿Podéis confirmar disponibilidad, precio total con transporte o recogida y plazo de fabricación?');
    lines.push('');
    if(details){
      lines.push('*DATOS PARA VALORAR LA SOLICITUD*');
      if(details.name){lines.push('Nombre/empresa: '+details.name);}
      if(details.location){lines.push('Municipio o recogida: '+details.location);}
      if(details.postal){lines.push('Código postal: '+details.postal);}
      if(details.comments){lines.push('Observaciones: '+details.comments);}
      if(cart.note){lines.push('Nota del carrito: '+cart.note);}
      lines.push('');
    }
    lines.push('Solicitud informativa; no es un pedido confirmado.');
    return lines.join('\n');
  }

  function setFeedback(container,message,isError){
    var target=container&&container.querySelector('[data-cb-quote-feedback]');
    if(!target){return;}
    target.textContent=message;
    target.hidden=!message;
    target.classList.toggle('is-error',!!isError);
  }

  function downloadCopy(text){
    var today=new Date().toISOString().slice(0,10);
    var blob=new Blob([text],{type:'text/plain;charset=utf-8'});
    var url=URL.createObjectURL(blob);
    var anchor=document.createElement('a');
    anchor.href=url;
    anchor.download='CocinaBarata-resumen-presupuesto-'+today+'.txt';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(function(){URL.revokeObjectURL(url);},2500);
  }

  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-cb-quote-send],[data-cb-quote-download]');
    if(!button){return;}
    event.preventDefault();
    var box=button.closest('[data-cb-quote]');
    if(!box||button.disabled){return;}
    var sending=button.hasAttribute('data-cb-quote-send');
    button.disabled=true;
    setFeedback(box,'Preparando tu resumen con las medidas y precios del carrito...',false);
    fetchCurrentCart().then(function(cart){
      if(!cart.items||!cart.items.length){throw new Error('No hay artículos en el carrito. Añade primero los productos que quieres consultar.');}
      function fieldValue(selector){
        var input=box.querySelector(selector);
        return input?String(input.value||'').trim():'';
      }
      var details={
        name:fieldValue('[data-cb-quote-name]'),
        location:fieldValue('[data-cb-quote-location]'),
        postal:fieldValue('[data-cb-quote-postal]'),
        comments:fieldValue('[data-cb-quote-comments]')
      };
      var text=quoteText(cart,details);
      if(sending){
        var phone=(box.getAttribute('data-cb-quote-phone')||'').replace(/\D/g,'');
        if(!phone){throw new Error('No está configurado el teléfono de destino.');}
        var url='https://wa.me/'+phone+'?text='+encodeURIComponent(text);
        if(url.length>9000){
          throw new Error('El resumen es muy largo para enviarlo en un enlace de WhatsApp. Utiliza «Guardar una copia» y compártela por WhatsApp.');
        }
        try {
          downloadCopy(text);
          setFeedback(box,'Copia preparada para guardar en tu dispositivo. Se abrirá WhatsApp; revisa el mensaje y pulsa «Enviar».',false);
        } catch(copyError) {
          setFeedback(box,'Se abrirá WhatsApp. Si necesitas una copia adicional, vuelve al carrito y pulsa «Guardar copia del presupuesto».',false);
        }
        window.setTimeout(function(){ window.location.assign(url); },350);
      }else{
        downloadCopy(text);
        setFeedback(box,'Copia guardada. También puedes enviarnos el mismo resumen por WhatsApp.',false);
      }
    }).catch(function(error){
      setFeedback(box,error&&error.message?error.message:'No se ha podido preparar el resumen. Inténtalo de nuevo.',true);
    }).finally(function(){button.disabled=false;});
  });
  // La casilla de confirmación de medidas se marca de nuevo en el carrito, antes del pago.
  document.addEventListener('click',function(event){
    var checkout=event.target.closest('#checkout,#CartDrawer-Checkout');
    if(!checkout){return;}
    var area=checkout.closest('#main-cart-footer,#CartDrawer');
    if(!area){return;}
    var confirmations=area.querySelectorAll('.cb-cart-order-confirm input[type="checkbox"][required]');
    for(var i=0;i<confirmations.length;i++){
      if(!confirmations[i].checked){
        event.preventDefault();
        event.stopImmediatePropagation();
        var details=confirmations[i].closest('details');
        if(details){details.open=true;}
        var feedback=area.querySelector('[data-cb-checkout-warning]');
        if(feedback){feedback.hidden=false;}
        confirmations[i].scrollIntoView({block:'center',behavior:'smooth'});
        confirmations[i].focus({preventScroll:true});
        confirmations[i].reportValidity();
        return;
      }
    }
  },true);
  document.addEventListener('change',function(event){
    if(!event.target.matches('.cb-cart-order-confirm input[type="checkbox"]')){return;}
    var area=event.target.closest('#main-cart-footer,#CartDrawer');
    if(!area){return;}
    var feedback=area.querySelector('[data-cb-checkout-warning]');
    if(feedback){feedback.hidden=Array.from(area.querySelectorAll('.cb-cart-order-confirm input[type="checkbox"][required]')).every(function(input){return input.checked;});}
  });

})();